// crea un footer en el que se incluya las políticas de privacidad y coookies, aviso legal y términos y condiciones
import { FC } from "react";
import { Row } from "reactstrap";
import "./Footer.css";

const Footer: FC = () => {
  return (
    <>
      <Row tag="footer" className="pt-1">
        <ul className="list">
    
        </ul>
      </Row>
    </>
  );
};

export default Footer;
